import type { ElectricalSlots } from "building-types/electrical/electricalSlots";
import { ControllerTypeSlot } from "building-types/electrical/electricalSlots";
import type { ControllerType } from "building-types/electrical/electricalTypesEnum";

export function controllerTypeFromSlots(
  controllerTypeSlot: ControllerTypeSlot | undefined,
  slots: ElectricalSlots,
): ControllerType {
  const { controllers } = slots;

  if (controllerTypeSlot === undefined) {
    return slots.controllers.primary;
  }

  switch (controllerTypeSlot) {
    case ControllerTypeSlot.PRIMARY:
      return controllers.primary;
    case ControllerTypeSlot.SECONDARY:
      return controllers.secondary !== undefined ? controllers.secondary : controllers.primary;
    case ControllerTypeSlot.TERTIARY:
      if (controllers.tertiary !== undefined) {
        return controllers.tertiary;
      } else if (controllers.secondary !== undefined) {
        return controllers.secondary;
      }
      return controllers.primary;
    case ControllerTypeSlot.QUATERNARY:
      if (controllers.quaternary !== undefined) {
        return controllers.quaternary;
      } else if (controllers.tertiary !== undefined) {
        return controllers.tertiary;
      } else if (controllers.secondary !== undefined) {
        return controllers.secondary;
      }
      return controllers.primary;
  }
}
